import React from 'react';
import { 
  History, 
  Award, 
  Factory, 
  Package, 
  Leaf, 
  Globe,
  CheckCircle
} from 'lucide-react';
import { achievements } from '../../../data/team';

const Achievements: React.FC = () => {
  // Function to get the appropriate icon based on the icon name
  const getIcon = (iconName: string | undefined) => {
    switch (iconName) {
      case 'History':
        return <History size={28} className="text-secondary" />;
      case 'Award':
        return <Award size={28} className="text-secondary" />;
      case 'Factory':
        return <Factory size={28} className="text-secondary" />;
      case 'Package':
        return <Package size={28} className="text-secondary" />;
      case 'Leaf':
        return <Leaf size={28} className="text-secondary" />;
      case 'Globe':
        return <Globe size={28} className="text-secondary" />;
      default:
        return <CheckCircle size={28} className="text-secondary" />;
    }
  };

  return (
    <section className="py-16 bg-primary-50">
      <div className="container-wide">
        <div className="section-title">
          <h2>Naši dosežki</h2>
          <div className="divider"></div>
          <p>
            Skozi desetletja smo dosegli številne mejnike in prejeli priznanja,
            ki potrjujejo našo zavezanost kakovosti in tradiciji.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {achievements.map(achievement => (
            <div 
              key={achievement.id} 
              className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-all card-glow"
            >
              <div className="mb-4">
                {getIcon(achievement.icon)}
              </div>
              
              <div className="inline-block bg-primary-100 text-primary-800 text-sm font-medium px-3 py-1 rounded-full mb-4">
                {achievement.year}
              </div>
              
              <h3 className="text-xl font-bold text-primary-700 mb-2">
                {achievement.title}
              </h3>
              
              <p className="text-accent-700">
                {achievement.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 bg-white p-8 rounded-lg shadow-md">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-primary-700 mb-2">
              Naša zavezanost kakovosti
            </h3>
            <p className="text-accent-700 max-w-3xl mx-auto">
              V Oljarni Krajnc je kakovost na prvem mestu. Naša zavezanost kakovosti se kaže 
              v skrbni izbiri surovin, tradicionalnem postopku pridelave in nenehnem izboljševanju.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <QualityFeature 
              title="Lokalne surovine" 
              description="Uporabljamo izključno bučna semena lokalnih pridelovalcev."
              icon={<Leaf size={24} className="text-primary-600" />}
            />
            
            <QualityFeature 
              title="Brez dodatkov" 
              description="Naši izdelki ne vsebujejo konzervansov, barvil ali drugih dodatkov."
              icon={<CheckCircle size={24} className="text-primary-600" />}
            />
            
            <QualityFeature 
              title="Certificirana kakovost" 
              description="Ponosni smo na številne certifikate in priznanja za kakovost."
              icon={<Award size={24} className="text-primary-600" />}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

// Quality feature component
const QualityFeature: React.FC<{
  title: string;
  description: string;
  icon: React.ReactNode;
}> = ({ title, description, icon }) => {
  return (
    <div className="flex flex-col items-center text-center">
      <div className="bg-primary-100 p-4 rounded-full mb-4">
        {icon}
      </div>
      <h4 className="text-lg font-semibold text-primary-700 mb-2">{title}</h4>
      <p className="text-accent-700">{description}</p>
    </div>
  );
};

export default Achievements;